/**
 * כרטיס מצב בלוח הבקרה — DESIGN.md 8.2: "מספר גדול (Rubik 700, tabular),
 * תווית muted, אייקון Phosphor בנחושת."
 */
import type { Icon } from '@phosphor-icons/react';

interface StatCardProps {
  icon: Icon;
  label: string;
  value: number | null;
}

export function StatCard({ icon: IconComponent, label, value }: StatCardProps) {
  return (
    <div
      className="rounded-lg border border-line bg-canvas p-4"
      style={{ boxShadow: 'var(--shadow-card)' }}
    >
      <IconComponent
        size={24}
        weight="regular"
        aria-hidden="true"
        style={{ color: 'var(--color-copper)' }}
      />
      <p className="tabular mt-2 text-3xl font-bold">{value ?? '...'}</p>
      <p className="text-muted mt-1 text-sm">{label}</p>
    </div>
  );
}
